export default "__VITE_ASSET__BLxnGp0s__"